export default __webpack_public_path__ + "static/media/car-row.59031c0c.jpg";